import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService } from "primeng/api";
import { NavService } from "../../../_services/_nav.service";
import { UnidadMedidaCultivo } from "../../../_models/unidad-medida-cultivo";
import { UnidadesMedidasCultivosService } from "../../../_services/unidades-medidas-cultivos.service";

@Component({
  selector: "app-unidad-medida-form",
  templateUrl: "./unidad-medida-form.component.html",
  styleUrls: ["./unidad-medida-form.component.css"],
})
export class UnidadMedidaFormComponent implements OnInit {
  @Input() unidadMedidaCultivo: UnidadMedidaCultivo;
  @Input() unidadesMedidasCultivo: UnidadMedidaCultivo[] = [];
  @Output() dismiss: EventEmitter<any> = new EventEmitter();

  carInformacionInicial = true;
  guardando = false;
  submitted = false;
  formulario: FormGroup;
  codigoRepetido = false;

  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private navServicio: NavService,
    private unidadesMedidasCultivosService: UnidadesMedidasCultivosService
  ) {}

  ngOnInit() {
    this.cargarFormulario();
    this.carInformacionInicial = false;
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idUnidadMedidaCultivo: [
        this.unidadMedidaCultivo
          ? this.unidadMedidaCultivo.idUnidadMedidaCultivo
          : null,
      ],
      codigo: [
        this.unidadMedidaCultivo ? this.unidadMedidaCultivo.codigo : null,
        [Validators.required],
      ],
      nombre: [
        this.unidadMedidaCultivo ? this.unidadMedidaCultivo.nombre : null,
        [Validators.required],
      ],
      valorUnidadMedida: [
        this.unidadMedidaCultivo
          ? this.unidadMedidaCultivo.valorUnidadMedida
          : null,
        [Validators.required],
      ],
      indicadorHabilitado: [
        this.unidadMedidaCultivo
          ? this.unidadMedidaCultivo.indicadorHabilitado
          : true,
        [Validators.required],
      ],
    });
  }

  onSubmit() {
    this.submitted = true;
    this.unidadesMedidasCultivo.map((x) => {
      if (this.unidadMedidaCultivo) {
        if (
          this.f.codigo.value === x.codigo &&
          x.idUnidadMedidaCultivo !=
            this.unidadMedidaCultivo.idUnidadMedidaCultivo
        ) {
          this.codigoRepetido = true;
          return;
        }
      } else {
        if (this.f.codigo.value === x.codigo) {
          this.codigoRepetido = true;
          return;
        }
      }
    });

    if (this.formulario.valid) {
      this.conServicio.confirm({
        message: this.navServicio.buscarMensaje("MSG_GUARDARCAMBIOS"),
        header: this.navServicio.buscarMensaje("LBL_CONFIRMACION"),
        icon: "fa fa-question-circle",
        key: "unidad-medida-form",
        accept: () => {
          this.guardar();
        },
        reject: () => {},
      });
    }
  }

  guardar() {
    this.guardando = true;
    const registro = this.formulario.value;
    if (registro.idUnidadMedidaCultivo) {
      this.unidadesMedidasCultivosService.update(registro).subscribe(
        (res) => {
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
          this.navServicio.setMesage(2);
          const data = { seccion: "LIS", actualizar: true };
          this.dismiss.emit(data);
        },
        (error) => {
          this.guardando = false;
          this.navServicio.setMesage(3);
        }
      );
    } else {
      this.unidadesMedidasCultivosService.add(registro).subscribe(
        (res) => {
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
          this.navServicio.setMesage(1);
          const data = { seccion: "LIS", actualizar: true };
          this.dismiss.emit(data);
        },
        (error) => {
          this.guardando = false;
          this.navServicio.setMesage(3);
        }
      );
    }
  }

  get f() {
    return this.formulario.controls;
  }

  regresar() {
    const data = { seccion: "LIS", actualizar: false };
    this.dismiss.emit(data);
  }
}
